"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Phone, Mail, MapPin, Loader } from "lucide-react";
export default function Contact() {
  return <section id="contact" className="py-16 px-4 bg-light-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-display font-bold text-foreground-light mb-4">
            Get In Touch
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Ready to bring your vision to life? Contact us today and let's create something extraordinary together.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-start">
          {}
          <div className="space-y-8">
            <div className="space-y-6">
              <div className="flex items-start gap-4 group cursor-pointer transition-all duration-[var(--duration-medium)]">
                <div className="p-3 rounded-md bg-primary/10 group-hover:bg-primary/20 transition-colors duration-[var(--duration-medium)]">
                  <Phone className="size-6 text-primary" />
                </div>
                <div>
                  <h3 className="font-display font-semibold text-foreground-light mb-1">
                    Phone
                  </h3>
                  <p className="text-muted-foreground">+351 920 679 666</p>
                </div>
              </div>

              <div className="flex items-start gap-4 group cursor-pointer transition-all duration-[var(--duration-medium)]">
                <div className="p-3 rounded-md bg-primary/10 group-hover:bg-primary/20 transition-colors duration-[var(--duration-medium)]">
                  <Mail className="size-6 text-primary" />
                </div>
                <div>
                  <h3 className="font-display font-semibold text-foreground-light mb-1">
                    Email
                  </h3>
                  <p className="text-muted-foreground">marlonlupo13@gmail.com</p>
                </div>
              </div>

              
            </div>

            <div className="pt-8 border-t border-border">
              <h3 className="font-display font-semibold text-foreground-light mb-3">
                Business Hours
              </h3>
              <p className="text-muted-foreground">Mon-Fri: 9am - 6pm</p>
            </div>
          </div>

          {}
          <FormProvider className="bg-white rounded-lg shadow-soft p-8 border border-border" formId="contact-form-contact" sectionName="contact-section" defaultValues={{
          name: "",
          email: "",
          message: ""
        }} validationRules={{
          name: {
            required: true,
            minLength: 2,
            maxLength: 50
          },
          email: {
            required: true,
            pattern: "email"
          },
          message: {
            required: true,
            minLength: 10
          }
        }} submitText="Send Message" successMessage="Thank you for reaching out! We'll get back to you within 24 hours.">
            <ContactForm />
          </FormProvider>
        </div>
      </div>
    </section>;
}
function ContactForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="text-center py-8">
        <div className="inline-flex items-center justify-center size-16 rounded-full bg-primary/10 mb-4">
          <Mail className="size-8 text-primary" />
        </div>
        <h3 className="font-display font-semibold text-foreground-light text-xl mb-2">
          Message Sent!
        </h3>
        <p className="text-muted-foreground mb-6">{successMessage}</p>
        <Button onClick={resetForm} variant="outline">
          Send Another Message
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit}>
      <div className="space-y-6">
        <FormField control={control} name="name" rules={{
        required: "Name is required",
        minLength: {
          value: 2,
          message: "Name must be at least 2 characters"
        },
        maxLength: {
          value: 50,
          message: "Name must be less than 50 characters"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Name</FormLabel>
              <FormControl>
                <Input placeholder="Your Name" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Please enter a valid email address"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Email</FormLabel>
              <FormControl>
                <Input type="email" placeholder="you@example.com" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="message" rules={{
        required: "Message is required",
        minLength: {
          value: 10,
          message: "Message must be at least 10 characters"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Message</FormLabel>
              <FormControl>
                <Textarea placeholder="Tell us about your project..." className="min-h-32" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {submitError && <div className="p-4 bg-red-50 border border-red-200 rounded-md">
            <p className="text-sm text-red-800">{submitError}</p>
          </div>}

        <Button type="submit" disabled={isSubmitting} className="w-full hover:scale-[1.02] transition-transform duration-[120ms]">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-4" />
              Sending...
            </> : 'Send Message'}
        </Button>
      </div>
    </Form>;
}